<template>
  <v-dialog
    v-model="opened"
    max-width="450"
    content-class="rating-dialog"
    persistent
  >
    <h3 class="rating-dialog__title">
      {{ $t('workersList.setDriverRating') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <div class="rating-dialog__params-wrapper">
      <star-rating @rating-selected ="setRating"/>
    </div>

    <v-btn class="mt-5 elevation-0" color="warning" block @click="onSave">
      {{ $t('common.btns.rate') }}
    </v-btn>
  </v-dialog>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating,
  },
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    driver_id: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data: () => ({
    rating: 0,
  }),
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    async onSave() {
      const formData = {
        grade: this.rating,
        driver_id: this.driver_id,
      };

      await this.$store.dispatch('workers-board/addDriverGrade', {
        formData,
      });
      this.opened = false;
    },
    setRating(rating) {
      this.rating = rating;
    },
  },
};
</script>

<style lang="scss">
.rating-dialog {
  padding: 10px 15px;
  background-color: #fff;

  &__params-wrapper {
    display: flex;
    justify-content: space-between;

    ul {
      padding: 0;

      &:not(:last-child) {
        margin-right: 15px;
      }

      li {
        list-style: none;
      }
    }
  }

  h3 {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    line-height: 1.3;
    color: #424242;
  }
}
</style>
